export const SEARCH_ID_REQUEST='SEARCH_ID_REQUEST'
export const SEARCH_ID_SUCCESS='SEARCH_ID_SUCCESS'
export const SEARCH_ID_FAILURE='SEARCH_ID_FAILURE'

export const SEARCH_NAME_REQUEST='SEARCH_NAME_REQUEST'
export const SEARCH_NAME_SUCCESS='SEARCH_NAME_SUCCESS'
export const SEARCH_NAME_FAILURE='SEARCH_NAME_FAILURE'